//UPDATED product_reducer.js - Fix these specific cases for immediate stats
const initial_state = {
  products: [],
  active_products: [],
  draft_products: [],
  archived_products: [],
  categories: [],
  loader: false,
  inventoryItems: [], // ✅ ADD this for inventory support
};

const productsReducer = (state = initial_state, action) => {
  switch (action.type) {
    case "GET_CATEGORIES":
      console.log(action);
      return Object.assign({}, state, {
        categories: action.categories,
        loader: false,
      });

    case "GET_PRODUCTS":
      console.log(action);
      return {
        ...state,
        products: [...action.products],
        loader: false,
      };

    // ✅ FIXED: Enhanced POST_PRODUCTS to handle duplicates and immediate updates
    case "POST_PRODUCTS": {
      console.log("🔄 POST_PRODUCTS - received:", action.products);

      // Check if product already exists
      const existingIndex = state.products.findIndex(
        (p) => p.POID === action.products.POID || p.id === action.products.id,
      );

      let updatedProducts;
      if (existingIndex >= 0) {
        // Update existing product
        updatedProducts = [...state.products];
        updatedProducts[existingIndex] = action.products;
        console.log("✅ Updated existing product in main array");
      } else {
        // Add new product
        updatedProducts = [...state.products, action.products];
        console.log("✅ Added new product to main array");
      }

      // ✅ IMPORTANT: Don't auto-add to filtered arrays here - let specific actions handle it
      return {
        ...state,
        products: updatedProducts,
      };
    }

    case "GET_ACTIVE_PRODUCTS":
      return Object.assign({}, state, {
        active_products: action.active_products,
      });

    case "GET_DRAFT_PRODUCTS":
      return Object.assign({}, state, {
        draft_products: action.draft_products,
      });

    case "GET_ARCHIVED_PRODUCTS":
      return Object.assign({}, state, {
        archived_products: action.archived_products,
      });

    // ✅ FIXED: Correct property names and handle duplicates
    case "POST_ACTIVE_PRODUCTS": {
      console.log("🔄 POST_ACTIVE_PRODUCTS - received:", action.active_product);

      // Check if product already exists in active_products
      const existingIndex = state.active_products.findIndex(
        (p) =>
          p.POID === action.active_product.POID ||
          p.id === action.active_product.id,
      );

      if (existingIndex >= 0) {
        // Update existing
        const updated = [...state.active_products];
        updated[existingIndex] = action.active_product;
        console.log("✅ Updated existing product in active_products");
        return {
          ...state,
          active_products: updated,
        };
      } else {
        // Add new
        console.log("✅ Added new product to active_products");
        return {
          ...state,
          active_products: [...state.active_products, action.active_product],
        };
      }
    }

    // ✅ FIXED: Correct property names and handle duplicates
    case "POST_DRAFT_PRODUCTS": {
      console.log("🔄 POST_DRAFT_PRODUCTS - received:", action.draft_product);

      // Check if product already exists in draft_products
      const existingIndex = state.draft_products.findIndex(
        (p) =>
          p.POID === action.draft_product.POID ||
          p.id === action.draft_product.id,
      );

      if (existingIndex >= 0) {
        // Update existing
        const updated = [...state.draft_products];
        updated[existingIndex] = action.draft_product;
        console.log("✅ Updated existing product in draft_products");
        return {
          ...state,
          draft_products: updated,
        };
      } else {
        // Add new
        console.log("✅ Added new product to draft_products");
        return {
          ...state,
          draft_products: [...state.draft_products, action.draft_product],
        };
      }
    }

    case "POST_ARCHIVED_PRODUCTS":
      return {
        ...state,
        archived_products: [
          ...state.archived_products,
          action.archived_products,
        ],
      };

    // ✅ KEEP: These are correctly added
    case "EDIT_PRODUCTS_STATUS": {
      console.log("🔄 EDIT_PRODUCTS_STATUS - updating product:", action.productId);
      const updatedProductMsg = action.updatedProduct;
      const targetId = action.productId;

      // 1. Update Main Products Array
      const newProducts = state.products.map((product) =>
        product.POID === targetId || product.id === targetId
          ? { ...product, ...updatedProductMsg }
          : product
      );

      // 2. Handle Active Products List
      let newActiveProducts = [...state.active_products];
      const isActive = updatedProductMsg.status === "Active";
      const isInActiveList = newActiveProducts.some(p => p.POID === targetId || p.id === targetId);

      if (isActive) {
        if (isInActiveList) {
          // Update existing in active list
          newActiveProducts = newActiveProducts.map(p =>
            p.POID === targetId || p.id === targetId ? { ...p, ...updatedProductMsg } : p
          );
        } else {
          // Add to active list (find from newProducts to have full data)
          const fullProduct = newProducts.find(p => p.POID === targetId || p.id === targetId);
          if (fullProduct) newActiveProducts.push(fullProduct);
        }
      } else {
        // Remove from active list if it was there but now not Active
        newActiveProducts = newActiveProducts.filter(p => p.POID !== targetId && p.id !== targetId);
      }

      // 3. Handle Draft Products List
      let newDraftProducts = [...state.draft_products];
      const isDraft = updatedProductMsg.status === "Draft";
      const isInDraftList = newDraftProducts.some(p => p.POID === targetId || p.id === targetId);

      if (isDraft) {
        if (isInDraftList) {
          // Update existing in draft list
          newDraftProducts = newDraftProducts.map(p =>
            p.POID === targetId || p.id === targetId ? { ...p, ...updatedProductMsg } : p
          );
        } else {
          // Add to draft list
          const fullProduct = newProducts.find(p => p.POID === targetId || p.id === targetId);
          if (fullProduct) newDraftProducts.push(fullProduct);
        }
      } else {
        // Remove from draft list if it was there but now not Draft
        newDraftProducts = newDraftProducts.filter(p => p.POID !== targetId && p.id !== targetId);
      }

      return {
        ...state,
        products: newProducts,
        active_products: newActiveProducts,
        draft_products: newDraftProducts,
      };
    }

    case "REMOVE_DRAFT_PRODUCT":
      console.log("🔄 REMOVE_DRAFT_PRODUCT - removing:", action.productId);
      return {
        ...state,
        draft_products: state.draft_products.filter(
          (product) =>
            product.POID !== action.productId &&
            product.id !== action.productId,
        ),
      };

    case "UPDATE_PRODUCT_QUANTITY":
      return {
        ...state,
        products: state.products.map((product) =>
          product.POID === action.productId || product.id === action.productId
            ? { ...product, quantity: action.newQuantity }
            : product,
        ),
        active_products: state.active_products.map((product) =>
          product.POID === action.productId || product.id === action.productId
            ? { ...product, quantity: action.newQuantity }
            : product,
        ),
      };

    // ✅ ADD: New inventory management cases
    case "GET_INVENTORY_ITEMS":
      return {
        ...state,
        inventoryItems: Array.isArray(action.inventoryItems)
          ? action.inventoryItems
          : [],
        loader: false,
      };

    case "POST_INVENTORY_ITEM": {
      console.log("🔄 POST_INVENTORY_ITEM - received:", action.inventoryItem);

      const existingIndex = state.inventoryItems.findIndex(
        (item) =>
          item.POID === action.inventoryItem.POID ||
          item.productId === action.inventoryItem.productId,
      );

      if (existingIndex >= 0) {
        // Update existing
        const updatedItems = [...state.inventoryItems];
        updatedItems[existingIndex] = action.inventoryItem;
        return {
          ...state,
          inventoryItems: updatedItems,
        };
      } else {
        // Add new
        return {
          ...state,
          inventoryItems: [...state.inventoryItems, action.inventoryItem],
        };
      }
    }

    case "EDIT_INVENTORY_ITEM_QUANTITY": {
      console.log(
        "🔄 EDIT_INVENTORY_ITEM_QUANTITY - received:",
        action.inventoryItem,
      );

      const itemIndex = state.inventoryItems.findIndex(
        (item) =>
          item.POID === action.inventoryItem.POID ||
          item.productId === action.inventoryItem.productId,
      );

      if (itemIndex >= 0) {
        const updatedItems = [...state.inventoryItems];
        updatedItems[itemIndex] = {
          ...updatedItems[itemIndex],
          ...action.inventoryItem,
        };

        return {
          ...state,
          inventoryItems: updatedItems,
        };
      } else {
        // Add if doesn't exist
        return {
          ...state,
          inventoryItems: [...state.inventoryItems, action.inventoryItem],
        };
      }
    }

    case "EDIT_INVENTORY_ITEM_QUANTITY_PURCHASE": {
      const updatedInventoryItems = action.inventoryItems;
      const updatedInventoryItemqtyAccepted = action.qty;
      const singleInventoryDetail = action.singleItemInventory;
      const productId =
        action.productId ||
        (singleInventoryDetail?.POID || singleInventoryDetail?.id);

      if (!productId) {
        console.warn(
          "EDIT_INVENTORY_ITEM_QUANTITY_PURCHASE: productId is missing"
        );
        return state;
      }

      console.log(
        "Updating Product Quantity from Purchase",
        productId,
        updatedInventoryItemqtyAccepted
      );

      const updateProductList = (list) => {
        return list.map((product) => {
          if (product.POID === productId || product.id === productId) {
            return {
              ...product,
              quantity:
                Number(product.quantity || 0) +
                Number(updatedInventoryItemqtyAccepted),
            };
          }
          return product;
        });
      };

      return {
        ...state,
        products: updateProductList(state.products),
        active_products: updateProductList(state.active_products),
        inventoryItems: state.inventoryItems
          ? state.inventoryItems.map((item) => {
            if (item.POID === productId || item.productId === productId) {
              return {
                ...item,
                quantity:
                  Number(item.quantity || 0) +
                  Number(updatedInventoryItemqtyAccepted),
              };
            }
            return item;
          })
          : state.inventoryItems,
      };
    }

    // ✅ KEEP: Your existing quantity management cases (they work fine)
    case "EDIT_ACTIVE_PRODUCTS_QUANTITY": {
      const updated_product = action.updated_product[0];
      const targetId = updated_product?.childOf === "null" || !updated_product?.childOf
        ? updated_product?.POID
        : updated_product?.childOf;

      return {
        ...state,
        products: state.products.map(product => {
          if (product.POID === targetId || product.id === targetId) {
            return { ...product, quantity: updated_product.quantity };
          }
          return product;
        }),
        active_products: state.active_products.map(product => {
          if (product.POID === targetId || product.id === targetId) {
            return { ...product, quantity: updated_product.quantity };
          }
          return product;
        })
      };
    }

    case "EDIT_ACTIVE_PRODUCTS_QUANTITY_WEB": {
      const updated_product = action.updated_product;
      const targetId = updated_product?.childOf === "null" || !updated_product?.childOf
        ? updated_product?.POID
        : updated_product?.childOf;

      console.log("🔄 EDIT_ACTIVE_PRODUCTS_QUANTITY_WEB - updating ID:", targetId, "to", updated_product?.quantity);

      const updateList = (list) => list.map(product => {
        if (product && (product.POID === targetId || product.id === targetId)) {
          return { ...product, quantity: updated_product?.quantity };
        }
        return product;
      });

      return {
        ...state,
        products: updateList(state.products),
        active_products: updateList(state.active_products),
        // Also sync inventoryItems if they exist in this slice
        inventoryItems: Array.isArray(state.inventoryItems)
          ? state.inventoryItems.map(item => {
            if (item && (item.POID === targetId || item.id === targetId || item.productId === targetId)) {
              return { ...item, quantity: updated_product?.quantity };
            }
            return item;
          })
          : state.inventoryItems
      };
    }

    case "EDIT_ACTIVE_PRODUCTS_QUANTITY_ON_ORDER": {
      console.log("🔄 EDIT_ACTIVE_PRODUCTS_QUANTITY_ON_ORDER", action);
      const productIds = action.id;
      const quantities = action.quantity;
      const isAdd = action.add !== undefined;

      const updateList = (list) => {
        if (!list) return [];
        return list.map((item) => {
          const index = productIds.indexOf(item.POID);
          if (index !== -1) {
            const qtyChange = quantities[index];
            const currentQty = Number(item.quantity || 0);
            const newQty = isAdd
              ? currentQty + Number(qtyChange)
              : currentQty - Number(qtyChange);

            return {
              ...item,
              quantity: newQty,
            };
          }
          return item;
        });
      };

      return {
        ...state,
        products: updateList(state.products),
        active_products: updateList(state.active_products),
        inventoryItems: updateList(state.inventoryItems),
      };
    }

    case "SUBTRACT_ACTIVE_MULTIPLE_PRODUCTS_QUANTITY_ON_ORDER": {
      const orderMap = {};
      action.orders.forEach(order => {
        orderMap[order.productId] = (orderMap[order.productId] || 0) + order.quantity;
      });

      const subtractFromList = (list) => list.map(product => {
        const productId = product.POID || product.id;
        if (orderMap[productId]) {
          return {
            ...product,
            quantity: Number(product.quantity || 0) - Number(orderMap[productId])
          };
        }
        return product;
      });

      return {
        ...state,
        products: subtractFromList(state.products),
        active_products: subtractFromList(state.active_products),
        inventoryItems: Array.isArray(state.inventoryItems)
          ? subtractFromList(state.inventoryItems)
          : state.inventoryItems
      };
    }

    // ✅ FIXED: Simplified and working EDIT_ACTIVE_PRODUCTS
    case "EDIT_ACTIVE_PRODUCTS": {
      let updated_product = action.updated_product;

      console.log("🔄 EDIT_ACTIVE_PRODUCTS - received:", updated_product);

      // Handle both single object and array
      const updateData = Array.isArray(updated_product)
        ? updated_product[0]
        : updated_product;

      // Update main products array
      let newProducts = state.products.map((product) => {
        if (!product) return product;

        const productId = product.id || product.POID;
        const updateId = updateData.id || updateData.POID;

        if (productId == updateId) {
          console.log("✅ Found and updated product in main array");
          return {
            ...product,
            ...updateData,
            id: updateData.id || updateData.POID,
            POID: updateData.POID || updateData.id,
          };
        }
        return product;
      });

      // Update active_products array if product exists there
      let newActiveProducts = state.active_products.map((product) => {
        if (!product) return product;

        const productId = product.id || product.POID;
        const updateId = updateData.id || updateData.POID;

        if (productId == updateId) {
          console.log("✅ Found and updated product in active_products array");
          return {
            ...product,
            ...updateData,
            id: updateData.id || updateData.POID,
            POID: updateData.POID || updateData.id,
          };
        }
        return product;
      });

      return {
        ...state,
        products: newProducts,
        active_products: newActiveProducts,
      };
    }

    case "DELETE_ACTIVE_PRODUCTS":
      let prods = state.active_products.filter(
        (product) => product.POID !== action.POID,
      );
      return {
        ...state,
        active_products: prods,
      };

    case "CLEAR_PRODUCT_DATA":
      return initial_state;

    case "CLEAR_DATA":
      return {
        ...state,
        active_products: [],
      };

    case "LOADING_START":
      return {
        ...state,
        loader: true,
      };

    case "LOADING_END":
      return {
        ...state,
        loader: false,
      };

    default:
      return state;
  }
};

export default productsReducer;